import { CrudModel } from "./_crud";

export class BlogPostSubcategoryAppModel extends CrudModel {
	constructor() {
		super("app/blog_post_subcategory");
	}
}

export default new BlogPostSubcategoryAppModel();
